module.exports = __webpack_public_path__ + "img/icon35.172efc9b.png";